import React, { useCallback, useState } from 'react';
import { TemplateForm } from './TemplateForm';
import { CANJE_LOGIN_TITLE } from '../shared/Constantes';
import { IndexValue } from '../../types/IndexValue';
import { TemplateCanje } from './TemplateCanje';
import { FormInputs } from './FormInputs';
import { useGoogleReCaptcha } from 'react-google-recaptcha-v3';
import { GetLoginPayload } from '../shared/GetPayload';
import { GenericErrorHandler, TMRandRetryErrorHandler } from '../shared/GenericErrorHandler';
import { loginMutation } from '../../rest/mutations/login.post';
import { useMutation } from '@apollo/client';
import { Mutations } from '../../rest/Mutations';
import { Spinner } from '../shared/Spinner';
import { ResponseLogin } from '../../rest/models/ResponseLogin';

type FormLoginProps = {
  loginCallback: (response: ResponseLogin) => void;
  handleError: (message?: string) => void;
};

export const FormLogin = (props: FormLoginProps) => {
  const { executeRecaptcha } = useGoogleReCaptcha();
  const [validate] = useMutation<Mutations>(loginMutation);
  const [loading, setLoading] = useState(false);
  const [msg, setMsg] = useState<string | null>(null);

  const handleError = useCallback(
    (error: any) => {
      return TMRandRetryErrorHandler(error) === null
        ? GenericErrorHandler(props.handleError, error)
        : setMsg(TMRandRetryErrorHandler(error));
    },
    [props.handleError]
  );

  function showSpinner() {
    setLoading(true);
  }
  function hideSpinner() {
    setLoading(false);
  }

  const loginService = async (data: IndexValue) => {
    showSpinner();
    const googleToken = await getGoogleToken();

    if (!googleToken) {
      GenericErrorHandler(props.handleError, 'Inténtelo nuevamente');
      hideSpinner();
      return;
    }

    await validate({ variables: { input: GetLoginPayload(data, googleToken) } })
      .then((x) => {
        props.loginCallback(x?.data as ResponseLogin);
        hideSpinner();
      })
      .catch((x) => {
        handleError(x);
        hideSpinner();
      });
  };

  const getGoogleToken = async () => {
    if (!executeRecaptcha) return null;
    let token;
    try {
      token = await executeRecaptcha();
    } catch (e) {}

    return token;
  };

  if (loading) return <Spinner />;

  return (
    <TemplateCanje title={CANJE_LOGIN_TITLE} textAlign={'left'} message={msg}>
      <TemplateForm textoBoton="Continuar" callback={loginService} reset={false}>
        {[FormInputs]}
      </TemplateForm>
    </TemplateCanje>
  );
};
